<template>
	<div class="row">
		<!-- customar project  start -->
		<div class="col-xl-12">
			<div class="card">
				<div class="card-body">
					<div class="table-responsive">
						<table
							id="report-table"
							class="table table-bordered table-striped mb-0"
						>
							<thead>
								<tr>
									<th>S/N</th>
									<th>NAME OF PARTY</th>
									<th>ACRONYM</th>
									<th>LOGO</th>
									<th>STATUS</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(party, index) in parties" :key="'p' + party.id">
									<td>{{ index + 1 }}</td>
									<td>{{ party.description }}</td>
									<td>{{ party.abbreviation }}</td>
									<td>
										<img :src="party.logo" height="60px" width="60px" />
									</td>
									<td>
										<span class="badge bg-success">Registered </span>
									</td>
									<td>
										<router-link
											:to="`/parties/${party.id}/details`"
											class="btn btn-info"
										>
											<i class="feather icon-user"></i> View
										</router-link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- customar project  end -->
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { userHasPermission } from "@/utils/permissions";

export default {
	computed: {
		...mapGetters({
			parties: "parties/parties",
		}),
		can_update_party() {
			return userHasPermission("parties-update");
		},
	},

	methods: {
		getParties() {
			this.$store.dispatch("parties/getPartyRegisteredList");
		},
	},

	mounted() {
		this.getParties();
	},
};
</script>
